import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import TextInput from '@molecules/TextInput';
import AnalystSelector from '@molecules/AnalystSelector';
import { Td } from '@layout/Attendees';
import styled from 'styled-components';
import {
  updateOrganizationFieldAction,
  loadRulesRequestAction,
  updateOrganizationRequestAction,
  loadAnalystsListRequestAction,
} from '@actions/organizations';
import {
  selectOrganizationsEditForm,
  selectOrganizationsRules,
  selectAnalystsList,
} from '@selectors/organizations';
import countriesList from '@config/countries-list';
import languagesList from '@config/languages-list';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import { Dropdown, Multiselect } from '@atoms';
import { Whitespace } from '@layout/';

const StyledLabel = styled.div`
  box-sizing: border-box;
  color: rgb(175, 175, 175);
  cursor: default;
  display: block;
  font-family: Lato, sans-serif;
  font-size: 12px;
  padding-top: 3px;
  textalign: 'right';
`;

class Company extends Component {
  componentWillMount() {
    this.props.loadRules();
    this.props.loadAnalysts();
  }

  handleChange = (event) => {
    this.props.updateOrganizationField({
      [event.target.name]: event.target.value,
    });
  };

  handleRuleChange = (event, index, rules) => {
    this.props.updateOrganizationField({ rules });
    this.props.updateInfo();
  };

  handleDropdownChange = (payload) => {
    this.props.updateOrganizationField(payload);
  };

  handleAnalyticSelectAdd = (item, index) => {
    const {
      organizationsEditForm: { analysts },
    } = this.props;
    const itemFounded = index > -1;

    itemFounded &&
      this.props.updateOrganizationField({
        analysts: [...analysts, item],
      });
  };

  handleAnalyticSelectRemove = (item) => {
    const {
      organizationsEditForm: { analysts },
    } = this.props;

    this.props.updateOrganizationField({
      analysts: _.differenceWith(analysts, [item], _.isEqual),
    });
  };

  render() {
    const {
      organizationsEditForm: {
        id,
        name,
        company,
        rules: orgRules = [],
        country,
        lang,
        isActive,
        analysts,
      },
      allRules,
      updateInfo,
      analyticsList,
    } = this.props;
    const countriesOptions = Object.keys(countriesList).map((country) => ({
      label: country,
      value: country,
    }));
    const languagesOptions = Object.keys(languagesList).map((language) => ({
      label: language,
      value: language,
    }));
    const connectionOptions = [
      {
        label: 'Active',
        value: true,
      },
      {
        label: 'Deactivated',
        value: false,
      },
    ];
    const rulesOptions = allRules.map(({ description, id }) => ({
      label: description,
      value: id,
    }));

    console.log('Company: ', this.props);

    return (
      <table style={{ width: '100%' }}>
        <tbody>
          <tr key={id}>
            <Td style={{ width: '20%' }}>
              <TextInput
                underlined
                name="name"
                id="name"
                value={name}
                onChange={this.handleChange}
                className="name"
                onBlur={updateInfo}
                style={{ marginTop: 0 }}
                label={<FormattedMessage {...messages.name} />}
              />
            </Td>

            <Td style={{ width: '20%' }}>
              <TextInput
                underlined
                name="company"
                id="company"
                value={company}
                onChange={this.handleChange}
                className="company"
                onBlur={updateInfo}
                label={<FormattedMessage {...messages.company} />}
              />
            </Td>
            <Td style={{ width: '20%' }}>
              <Dropdown
                onChange={(value) => {
                  this.handleDropdownChange({ country: value });
                  updateInfo();
                }}
                options={countriesOptions}
                value={country}
                className="country-dropdown"
                label={<FormattedMessage {...messages.country} />}
              />
            </Td>
            <Td style={{ width: '20%' }}>
              <Dropdown
                id="lang"
                name="lang"
                onChange={(value) => {
                  this.handleDropdownChange({ lang: value });
                  updateInfo();
                }}
                options={languagesOptions}
                value={lang}
                className="language"
                label={<FormattedMessage {...messages.language} />}
              />
            </Td>
            <Td style={{ width: '20%' }}>
              <Dropdown
                id="isActive"
                name="isActive"
                className="activity-status"
                onChange={(value) => {
                  this.handleDropdownChange({ isActive: value });
                  updateInfo();
                }}
                options={connectionOptions}
                value={isActive ? 'Active' : 'Deactivated'}
                label={<FormattedMessage {...messages.connectionStatus} />}
              />
            </Td>
          </tr>
          <tr>
            <Td style={{ width: '20%' }}>
              <StyledLabel>
                <FormattedMessage {...messages.companyRules} />
              </StyledLabel>

              <Multiselect
                fullWidth
                onChange={this.handleRuleChange.bind(this)}
                options={rulesOptions}
                value={orgRules}
                hintText="Select rules"
                className="select-rules"
                labelStyle={{ fontSize: '12px' }}
              />
            </Td>
            <Td style={{ width: '20%' }}>
              <StyledLabel>
                <FormattedMessage {...messages.companyAnalyst} />
              </StyledLabel>
              <Whitespace size="3px" />
              <AnalystSelector
                list={analyticsList}
                selectedList={analysts}
                onAdd={this.handleAnalyticSelectAdd}
                onRemove={this.handleAnalyticSelectRemove}
              />
            </Td>
            <Td colSpan="3" />
          </tr>
        </tbody>
      </table>
    );
  }
}

Company.propTypes = {
  country: PropTypes.string,
};

Company.defaultProps = {};

const mapStateToProps = (state) => ({
  organizationsEditForm: selectOrganizationsEditForm(state),
  allRules: selectOrganizationsRules(state),
  analyticsList: selectAnalystsList(state),
});

const mapDispatchToProps = {
  updateOrganizationField: updateOrganizationFieldAction,
  loadRules: loadRulesRequestAction,
  updateInfo: updateOrganizationRequestAction,
  loadAnalysts: loadAnalystsListRequestAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Company);



// WEBPACK FOOTER //
// ./components/molecules/Company/index.js